import { useMutation } from "react-query";
import AuthServices from "@/services/auth.service";

export const useLogin = () => {
    return useMutation({
        mutationFn: (data: any) => AuthServices.create(data),
    });
};